import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/brand/Logo";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();

  if (!ready || user === null) {
    return (
      <div className="grid min-h-screen place-items-center bg-am-bg">
        <div className="animate-pulse"><Logo size={56} /></div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
